import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import moment from 'moment';
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = 1945;
    while (startYear <= currentYear) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }
    return years;
}

var reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
        var newObj = {};
        if (data['position_grade'] != null && data['position_grade'] > 0) {
            newObj["label"] = data[label] + ' (Grade ' + data['position_grade'] + ')';
        } else {
            newObj["label"] = data[label];
        }

        newObj["value"] = data[value];
        newObj["model"] = data;
        console.log(newObj);
        return newObj;
    });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();
    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search);

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                uuid: "",
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
            },
            type: null,
            rumpunOptions: [],
            educationOptions: [],
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            typeriwayat: this.queryParams.get('type'),
            isgelarselected: null,
            jabatanOption: [],
            opt_jenis_pencantuman_gelar: [
                { value: 1, label: 'Tugas Belajar' },
                { value: 2, label: 'Izin Belajar' },
                { value: 3, label: 'Telah Memiliki sebelum CPNS' },
            ],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 9999,
                sort_order: {
                    column: 'position_id',
                    order: 'asc'
                }
            },
        }
    }

    getType = () => {
        let type = this.queryParams.get('type');

        if (type == 'riwayat') {
            return 'Riwayat Pendidikan'
        } else if (type == 'gelar') {
            return 'Pencantuman Gelar'
        } else {
            return 'Riwayat Pendidikan'
        }
    }
    loadPosition = async (uuid) => {
        let offset = (this.state.positionFilter.page_number - 1) * this.state.positionFilter.page_size
        const query = {
            uuid: uuid,
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1,
            position_type: this.state.position_type
        }
        this.setState({ loadingPosition: true })
        await this.createBloc.fetchListJabatan(query)
    }
    dateParse = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    submitData = async () => {
        // const formData = generateFormData(this.state.dataForm, ['file_ijazah', 'file_akre', 'file_penyetaraan']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        const formData = generateFormData(this.state.dataForm, ['file_ijazah', 'file_akre', 'file_penyetaraan','sk_tubel','surat_izin_belajar','surat_kronologi','nota_dinas','sk_pangkat'])
        await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                education_background_employee_uuid: this.state.dataForm.education_background_employee_uuid
            },
            confirm: true
        })
    }

    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }
    

    componentDidMount() {
        this.loadPosition('')
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        var labelisgelar = '';
                        if(response.education_background_isgelar == 1){
                            labelisgelar = 'Tugas Belajar';
                        }else if(response.education_background_isgelar == 2){
                            labelisgelar = 'Izin Belajar';
                        }else if(response.education_background_isgelar == 3){
                            labelisgelar = 'Telah Memiliki sebelum CPNS';
                        }else{
                            labelisgelar = ''
                        }
                        
                        // load to form
                        this.setState({
                            dataForm: {
                                uuid: response.education_background_uuid,
                                education_background_certificate_date: response.education_background_certificate_date,
                                education_background_certificate_number: response.education_background_certificate_number,
                                education_background_education_name: response.education_background_education_name,
                                education_background_education_uuid: response.education_background_education_uuid,
                                education_background_employee_uuid: response.education_background_employee_uuid,
                                education_background_end_title: response.education_background_end_title,
                                education_background_front_title: response.education_background_front_title,
                                education_background_graduation_year: response.education_background_graduation_year,
                                education_background_school_address: response.education_background_school_address,
                                education_background_school_major: response.education_background_school_major,
                                education_background_school_name: response.education_background_school_name,
                                education_background_title_sk_date: response.education_background_title_sk_date,
                                education_background_title_sk_document_uuid: response.education_background_title_sk_document_uuid,
                                education_background_title_sk_number: response.education_background_title_sk_number,
                                education_background_education_group_uuid: response.education_background_education_group_uuid,
                                education_background_isgelar: response.education_background_isgelar,
                                education_background_parent_position_uuid: response.education_background_parent_position_uuid,

                                document: response.document,
                                document_ijazah: response.document_ijazah,
                                document_akreditasi: response.document_akreditasi,
                                document_penyetaraan: response.document_penyetaraan,
                                
                            },
                            isgelarselected: {value: (response.education_background_isgelar!=null? parseInt(response.education_background_isgelar):0) ,label: labelisgelar},
                            detail: response,
                            type: response.education_background_isgelar,
                        })
                        console.log({value: (response.education_background_isgelar!=null? parseInt(response.education_background_isgelar):0) ,label: labelisgelar})
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.educationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            educationOptions: this.reformatOptions(
                                response.result,
                                "education_name",
                                "education_uuid"
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.updateBloc.rumpunChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            rumpunOptions: this.reformatOptions(
                                response.result,
                                "education_group_name",
                                "education_group_uuid"
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        const search = window.location.search
        const queryParams = new URLSearchParams(search)

        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })
        // this.updateBloc.fetchEducation()
        let type = this.queryParams.get('type')
        this.updateBloc.fetchEducation(
            {
                is_college: (type == 'gelar' ? 1 : 0)
            }
        )
        this.updateBloc.fetchRumpun(
            {
                is_college: (type == 'gelar' ? 1 : 2)
            }
        )
        this.createBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    this.setState({ jabatanOption: reformatOptions(result.data.response.result, 'position_name', 'position_uuid') })

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel.unsubscribe()
        this.updateBloc.educationChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayat_pendidikan" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit {this.getType()}</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />


                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="uuid"
                                            value={this.state.dataForm.uuid}
                                        />
                                        {(this.state.typeriwayat =="gelar" && this.state.type != null)?
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                                >
                                                Jenis Pencantuman Gelar <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    id="employee_transfer_detail_type"
                                                    options={this.state.opt_jenis_pencantuman_gelar}
                                                    value={this.state.isgelarselected || ""}
                                                    onChange={opt => this.setState({ type: opt.value, isgelarselected: opt})}
                                                  
                                                    validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                            <AvField
                                                name="employee_transfer_detail_type"
                                                type="hidden"
                                                value={this.state.type}
                                            />
                                        </Row>
                                        :''
                                        }
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tingkat Pendidikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect
                                                    name="education_background_education_uuid"
                                                    errorMessage="Pilih Jenjang"
                                                    options={this.state.educationOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Jenjang"
                                                    defaultValue={this.state.dataForm.education_background_education_uuid}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Rumpun
                                            </label>
                                            <Col md="4">
                                                <CustomSelect
                                                    name="education_background_education_group_uuid"
                                                    errorMessage="Pilih Rumpun"
                                                    options={this.state.rumpunOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Rumpun"
                                                    defaultValue={this.state.dataForm.education_background_education_group_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Sekolah / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="education_background_school_name"
                                                    id="education_background_school_name"
                                                    placeholder="Nama Sekolah / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Nama Sekolah / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jurusan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="education_background_school_major"
                                                    id="education_background_school_major"
                                                    placeholder="Jurusan"
                                                    type="text"
                                                    errorMessage="Masukan Jurusan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_major}
                                                />
                                            </Col>
                                        </Row>
                                        {(this.state.typeriwayat =="riwayat")?
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Alamat Sekolah / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="education_background_school_address"
                                                    id="education_background_school_address"
                                                    placeholder="Alamat Sekolah / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Alamat Sekolah / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_address}
                                                />
                                            </Col>
                                        </Row>
                                        :''}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nomor Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="education_background_certificate_number"
                                                    id="education_background_certificate_number"
                                                    placeholder="Nomor Ijazah"
                                                    type="text"
                                                    errorMessage="Masukan Nomor Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_certificate_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="education_background_certificate_date"
                                                    id="education_background_certificate_date"
                                                    placeholder="Tanggal Ijazah"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_certificate_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tahun Lulus <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect
                                                    name="education_background_graduation_year"
                                                    errorMessage="Pilih Tahun Lulus"
                                                    options={this.state.yearOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun Lulus"
                                                    defaultValue={this.state.dataForm.education_background_graduation_year}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Pendukung</Label>
                                            <Col md="8">
                                                <FileInput
                                                    name="file"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Ijazah & Transkrip Nilai</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_ijazah"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_ijazah !== null ?
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_ijazah?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                    : ' '}
                                                            </>
                                                            :
                                                            <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Akreditasi Program Studi</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_akre"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_akreditasi !== null ?
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_akreditasi?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                    : ' '}
                                                            </>
                                                            :
                                                            <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Penyetaraan Ijazah Bagi Lulusan Luar Negeri</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_penyetaraan"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_penyetaraan !== null ?
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_penyetaraan?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                    : ' '}
                                                            </>
                                                            :
                                                            <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Depan 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_front_title"
                                                    id="education_background_front_title"
                                                    placeholder="Gelar Depan"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Depan"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_front_title}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Belakang 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_end_title"
                                                    id="education_background_end_title"
                                                    placeholder="Gelar Belakang"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Belakang"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_end_title}
                                                />
                                            </Col>
                                        </Row>

                                        {(this.state.typeriwayat =="gelar" && this.state.dataForm?.education_background_isgelar != null)?
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jabatan Yang Membidangi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                            <CustomSelect
                                                        name="education_background_parent_position_uuid"
                                                        options={this.state.jabatanOption}
                                                        //optionLabel="position_name"
                                                        //optionValue="position_uuid"
                                                        errorMessage="Pilih Jabatan Yang Membidangi"
                                                        defaultValue={this.state.dataForm?.education_background_parent_position_uuid}
                                                        isLoading={this.state.loadingPosition}
                                                        validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                        </Row>
                                        :''
                                        }

                                        {(this.state.type == 1 && this.state.typeriwayat =="gelar")?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">SK Tugas Belajar <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="sk_tubel"

                                                    validate={{ required: { value: (this.state.detail?.document_tubel==null)?true:false } }}
                                                    col="6"
                                                    />
                                            <div className="mt-2">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_tubel !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_tubel.documents_path}>
                                                                Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                            </div>
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        
                                        {(this.state.type == 2 && this.state.typeriwayat =="gelar")?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Surat Izin Belajar <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="surat_izin_belajar"
                                                    validate={{ required: { value: (this.state.detail?.document_izin_belajar==null)?true:false } }}
                                                    col="6"
                                                    />
                                            <div className="mt-2">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_izin_belajar !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_izin_belajar.documents_path}>
                                                                Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                            </div>
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        {(this.state.type == 3 && this.state.typeriwayat =="gelar")?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Surat Kronologi</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="surat_kronologi"
                                                    validate={{ required: { value: (this.state.detail?.document_kronologi==null)?true:false } }}
                                                    col="6"
                                                    />
                                            <div className="mt-2">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_kronologi !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_kronologi.documents_path}>
                                                                Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                            </div>
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        {(this.state.typeriwayat =="gelar" && this.state.dataForm?.education_background_isgelar != null)?
                                        <>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Nota Dinas <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="nota_dinas"
                                                    validate={{ required: { value: (this.state.detail?.document_notadinas==null)?true:false } }}
                                                    col="6"
                                                    />
                                            <div className="mt-2">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_notadinas !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_notadinas.documents_path}>
                                                                Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                            </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">SK Pangkat Terakhir <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="sk_pangkat"
                                                    validate={{ required: { value: (this.state.detail?.document_s_klastjab==null)?true:false } }}
                                                    col="6"
                                                    />
                                            <div className="mt-2">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_s_klastjab !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_s_klastjab.documents_path}>
                                                                Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                            </div>
                                            </Col>
                                        </Row>
                                        </>
                                        :''
                                        }

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayat_pendidikan">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayat_pendidikan' />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView
